import { render, staticRenderFns } from "./CampaignShowFull.vue?vue&type=template&id=0b6cc8d0"
import script from "./CampaignShowFull.vue?vue&type=script&lang=js"
export * from "./CampaignShowFull.vue?vue&type=script&lang=js"
import style0 from "./CampaignShowFull.vue?vue&type=style&index=0&id=0b6cc8d0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports